import { store } from './store.js';

export const MOBILE_QUERY = '(max-width: 879.98px)';
export const INTERMEDIATE_QUERY = '(max-width: 1099.98px)';

export const mobileMedia = window.matchMedia(MOBILE_QUERY);
export const intermediateMedia = window.matchMedia(INTERMEDIATE_QUERY);

export function isMobileLayout() {
  const forced = store.get('forcedView') || 'auto';
  if (forced === 'mobile') return true;
  if (forced === 'desktop') return false;
  return mobileMedia.matches;
}

export function isIntermediateWidth() {
  return intermediateMedia.matches;
}

export function onResponsiveMediaChange(callback) {
  [mobileMedia, intermediateMedia].forEach((media) => {
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', callback);
    } else if (typeof media.addListener === 'function') {
      media.addListener(callback);
    }
  });
}
